import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    InputLabel,
    OutlinedInput,
    Typography,
    useTheme
} from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import WarningIcon from '@mui/icons-material/Warning';

interface ChildComponentProps {
    isVisible: boolean;
    alertText?: string;
    confermationText?: string;
    titleText?: string;
    primaryButtonText?: string;
    bodyText?: string;
    onClose?(): any;
    onConfirm?(confermationValue?: string): void;
}

const ConfirmatioDialog: FC<ChildComponentProps> = (props) => {
    const { isVisible, alertText, confermationText, titleText, bodyText, primaryButtonText, onClose, onConfirm } = props;
    const [confermationValue, setConfermationValue] = useState('');
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <>
            <Dialog
                open={isVisible}
                onClose={onClose ?? undefined}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{t(titleText ?? 'CONFIRM_DELETE')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{t(bodyText ?? 'ARE_YOU_SURE_TO_DELETE')}</DialogContentText>
                    {alertText && (
                        <Typography
                            sx={{ fontWeight: 'bold', color: 'red', fontSize: '14px', display: 'flex', marginTop: '6px' }}
                            id="alert-dialog-description"
                        >
                            <WarningIcon fontSize="small" />
                            {t(alertText)}
                        </Typography>
                    )}
                    {confermationText && (
                        <FormControl fullWidth required sx={{ marginTop: '10px' }}>
                            <Typography sx={{ fontWeight: 'bold', fontSize: '16px', display: 'flex', marginBottom: '10px' }}>
                                {t(confermationText)}{' '}
                            </Typography>
                            <OutlinedInput
                                onChange={(d) => {
                                    setConfermationValue(d.target.value);
                                }}
                            />
                        </FormControl>
                    )}
                </DialogContent>
                <DialogActions>
                    {onClose && (
                        <Button
                            onClick={onClose}
                            style={{
                                border: '2px solid',
                                borderColor: theme.palette.secondary.main,
                                borderRadius: 7
                            }}
                        >
                            <Typography sx={{ color: theme.palette.primary.main }}> {t('NO')}</Typography>
                        </Button>
                    )}
                    <Button
                        autoFocus
                        style={{
                            border: '2px solid',
                            borderColor: theme.palette.primary.main,
                            borderRadius: 7,
                            background: theme.palette.primary.main
                        }}
                        onClick={() => onConfirm!(confermationValue)}
                    >
                        <Typography sx={{ color: '#fff' }}> {t(primaryButtonText ?? 'YES')}</Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ConfirmatioDialog;
